import type { ZoomAccess } from './zoomAccess';
import { shouldShowZoomDiagnostics } from './zoomSdk';

const REASON_LABEL: Record<
  Extract<ZoomAccess, { status: 'blocked' }>['reason'],
  string
> = {
  'no-sdk': 'ZCS:no-sdk',
  'config-failed': 'ZCS:config',
  'unsupported-api': 'ZCS:unsupported',
  'no-app-context': 'ZCS:context',
  'sdk-error': 'ZCS:sdk',
  timeout: 'ZCS:timeout',
};

/** Minimal in-Zoom startup feedback (blank off-Zoom in local dev only). */
export function AccessGate({ access }: { access: ZoomAccess }) {
  if (access.status === 'ready') {
    return null;
  }

  if (access.status === 'loading') {
    return <p className="access-hint">ZCS:…</p>;
  }

  if (!shouldShowZoomDiagnostics()) {
    return null;
  }

  const code = REASON_LABEL[access.reason];
  return (
    <p className="access-hint" title={access.detail}>
      {code}
    </p>
  );
}
